"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToPhoneNumberProps({ data, inHero }) {
    let phone = null;
    if (!('blockType' in data)) {
        phone = data;
    }
    else if (data.phoneNumberReference && typeof data.phoneNumberReference === 'object') {
        phone = data.phoneNumberReference;
    }
    return {
        children: phone?.text,
        mobileText: phone?.mobileText,
        staticPhoneNumber: phone?.staticPhoneNumber,
        cobra: phone?.cobra,
        cobraCartUrl: phone?.cobraCartUrl,
        cobraButtonText: phone?.cobraButtonText,
        color: phone?.color?.toLowerCase(),
        visibility: phone?.visibility,
        hidePhoneNumberOnMobile: phone?.hidePhoneNumberOnMobile,
        outlined: phone?.outlined,
        variant: inHero ? 'hero' : null,
    };
}
exports.default = mapToPhoneNumberProps;
